<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <div class="title">RANKING - {{ namespace }}</div>
  <app-datatable
    [columns]="columns"
    [rows]="ranklistRows"
    [searchControlSettings]="searchControlSettings"
    (filterChange)="onFilterChange($event)"
    [initialFilters]="filters"
    [isSelectTopSection]="true"
    [isTopSection]="true"
    [isCustomFooter]="true"
    [columnMode]="ColumnMode.force"
    [searchable]="false"
  ></app-datatable>
</nb-card>
